/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import {
    LeadgenDailyStat,
    LeadgenFilter,
    LeadgenHourlyStat,
    LeadgenInfo,
    LeadgenReferrallinkInfo,
    LeadgenStat,
} from 'models/api/leadgen';
import Table from 'models/api/table';
import { Key } from 'react';

export const getLeadgens = async (axios: AxiosInstance, requestParams: LeadgenFilter) => {
    const response = await axios.get<Table<LeadgenStat>>('/leadgen', {
        params: requestParams,
    });
    return response.data;
};

export const getLeadgenDailyStats = async (axios: AxiosInstance, requestParams: LeadgenFilter) => {
    const response = await axios.get<Table<LeadgenDailyStat>>('/leadgen/dailyStats', {
        params: requestParams,
    });
    return response.data;
};

export const getLeadgenHourlyStats = async (axios: AxiosInstance, requestParams: LeadgenFilter) => {
    const response = await axios.get<Table<LeadgenHourlyStat>>('/leadgen/hourlyStats', {
        params: requestParams,
    });
    return response.data;
};

export const getLeadgensItem = async (axios: AxiosInstance, id: Key) => {
    const response = await axios.get<LeadgenInfo>(`/leadgen/${id}`);
    return response.data;
};

export const addLeadgensItem = async (axios: AxiosInstance, info: LeadgenInfo) => {
    const response = await axios.post('/leadgen', info);
    return response.data;
};

export const updateLeadgensItem = async (axios: AxiosInstance, info: LeadgenInfo) => {
    const response = await axios.put(`/leadgen/${info.id}`, info);
    return response.data;
};

export const statusLeadgensItem = async (axios: AxiosInstance, id: Key, isActive: boolean) => {
    const response = await axios.put(`/leadgen/${id}/status`, isActive);
    return response.data;
};

export const deleteLeadgensItem = async (axios: AxiosInstance, id: Key) => {
    const response = await axios.delete(`/leadgen/${id}`);
    return response.data;
};

export const getLeadgenExcel = async (axios: AxiosInstance, requestParams: LeadgenFilter) => {
    const { data } = await axios.get<Blob>('/leadgen/excel', {
        responseType: 'arraybuffer',
        params: { ...requestParams },
    });
    return data;
};

export const getLeadgenDailyStatsExcel = async (
    axios: AxiosInstance,
    requestParams: LeadgenFilter
) => {
    const { data } = await axios.get<Blob>('/leadgen/dailyStatsExcel', {
        responseType: 'arraybuffer',
        params: { ...requestParams },
    });
    return data;
};

export const getLeadgenHourlyStatsExcel = async (
    axios: AxiosInstance,
    requestParams: LeadgenFilter
) => {
    const { data } = await axios.get<Blob>('/leadgen/hourlyStatsExcel', {
        responseType: 'arraybuffer',
        params: { ...requestParams },
    });
    return data;
};

export const getLeadgenNamesDropDown = async (axios: AxiosInstance) => {
    const response = await axios.get<DropDown[]>('/leadgen/nameList');
    return response.data;
};

export const getDefaultReferalLinks = async (axios: AxiosInstance, leadgenName: string) => {
    const response = await axios.get<LeadgenReferrallinkInfo[]>(`/leadgen/defaultReferalLinks`, {
        params: {
            leadgenName,
        },
    });
    return response.data;
};
